import React, { useState, useEffect } from 'react';
import Header from '../Header/Header.jsx';
import Footer from '../Footer/Footer.jsx';
import styles from './MerchandiseDesign.module.css';
import bookmark1 from '../../images/bookmark-1.jpg'
import bookmark2 from '../../images/bookmark-2.jpg'
import mobilecover1 from '../../images/mobile-cover-1.jpg'
import mobilecover2 from '../../images/mobile-cover-2.jpg'
import tag1 from '../../images/Tag-1.jpg'
import tag2 from '../../images/Tag-2.jpg'
import tag3 from '../../images/Tag-3.jpg'
import tag4 from '../../images/Tag-4.jpg'
import design1 from '../../images/Design-1.png'
import design2 from '../../images/Design-2.png'
import design3 from '../../images/Design-3.png'
import design4 from '../../images/Design-4.png'
import design5 from '../../images/Design-5.png'
import design6 from '../../images/Design-6.png'
import design7 from '../../images/Design-7.png'

const MerchandisePage = () => {
  const [activeCategory, setActiveCategory] = useState('all');
  const [hoveredItem, setHoveredItem] = useState(null);
  const [scrollY, setScrollY] = useState(0);
  const [menuOpen, setMenuOpen] = useState(false);
  const [mode, setMode] = useState('graphic');
  const [scrolled, setScrolled] = useState(false);
  const [selectedImage, setSelectedImage] = useState(null);

  useEffect(() => {
    const handleScroll = () => {
      setScrollY(window.scrollY);
      setScrolled(window.scrollY > 50);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const products = [
    {
      id: 1,
      name: 'Artistic Bookmark Set',
      category: 'bookmarks',
      image: bookmark1,
    },
    {
      id: 2,
      name: 'Minimalist Phone Case',
      category: 'mobile',
      image: mobilecover1,
    },
    {
      id: 3,
      name: 'Floral Bookmark Collection',
      category: 'bookmarks',
      image: bookmark2,
    },
    {
      id: 4,
      name: 'Gradient Mobile Cover',
      category: 'mobile',
      image: mobilecover2,
    },
    
    {
      id: 5,
      name: 'Minimalist Phone Case',
      category: 'tag',
      image: tag1,
    },
    {
      id: 6,
      name: 'Floral Bookmark Collection',
      category: 'tag',
      image: tag2,
    },
    {
      id: 7,
      name: 'Gradient Mobile Cover',
      category: 'tag',
      image: tag4,
    },
    {
      id: 8,
      name: 'Gradient Mobile Cover',
      category: 'tag',
      image: tag3,
    },
    { id: 9,  name: 'Customized Dress 1', category: 'dress', image: design1 },
    { id: 10, name: 'Customized Dress 2', category: 'dress', image: design2 },
    { id: 11, name: 'Customized Dress 3', category: 'dress', image: design3 },
    { id: 12, name: 'Customized Dress 4', category: 'dress', image: design4 },
    { id: 13, name: 'Customized Dress 5', category: 'dress', image: design5 },
    { id: 14, name: 'Customized Dress 6', category: 'dress', image: design6 },
    { id: 15, name: 'Customized Dress 7', category: 'dress', image: design7 },
  ];

  const filteredProducts = activeCategory === 'all' 
    ? products 
    : products.filter(p => p.category === activeCategory);

  return (
    <>
      <Header mode={mode} setMode={setMode} menuOpen={menuOpen} setMenuOpen={setMenuOpen} scrolled={scrolled} />
      
      <div className={styles.container}>
        {/* Animated Background */}
        <div className={styles.backgroundWrapper}>
          <div className={`${styles.gradientOrb} ${styles.orb1}`} style={{transform: `translate(${scrollY * 0.1}px, ${scrollY * 0.15}px)`}} />
          <div className={`${styles.gradientOrb} ${styles.orb2}`} style={{transform: `translate(${-scrollY * 0.08}px, ${scrollY * 0.12}px)`}} />
          <div className={`${styles.gradientOrb} ${styles.orb3}`} style={{transform: `translate(${scrollY * 0.05}px, ${-scrollY * 0.1}px)`}} />
        </div>

      {/* Hero Section */}
      <section className={styles.hero}>
        <div className={styles.heroContent}>
          <h2 className={styles.heroTitle}>Premium Merchandise</h2>
          <p className={styles.heroSubtitle}>Discover unique designs for your everyday essentials</p>
        </div>
      </section>

      {/* Category Filter */}
      <div className={styles.filterSection}>
        <button
          className={`${styles.filterBtn} ${activeCategory === 'all' ? styles.filterBtnActive : ''}`}
          onClick={() => setActiveCategory('all')}
        >
          All Products
        </button>
        <button
          className={`${styles.filterBtn} ${activeCategory === 'bookmarks' ? styles.filterBtnActive : ''}`}
          onClick={() => setActiveCategory('bookmarks')}
        >
          Bookmarks
        </button>
        <button
          className={`${styles.filterBtn} ${activeCategory === 'mobile' ? styles.filterBtnActive : ''}`}
          onClick={() => setActiveCategory('mobile')}
        >
          Mobile Covers
        </button>
        <button
          className={`${styles.filterBtn} ${activeCategory === 'tag' ? styles.filterBtnActive : ''}`}
          onClick={() => setActiveCategory('tag')}
        >
          Luggage Tag
        </button>
        <button
          className={`${styles.filterBtn} ${activeCategory === 'dress' ? styles.filterBtnActive : ''}`}
          onClick={() => setActiveCategory('dress')}
        >
          Customized Dress
        </button>
      </div>

      {/* Products Grid */}
      <div className={styles.productsGrid}>
        {filteredProducts.map((product, index) => (
          <div
            key={product.id}
            className={styles.productCard}
            style={{
              animationDelay: `${index * 0.1}s`,
              transform: hoveredItem === product.id ? 'translateY(-10px) scale(1.02)' : 'translateY(0) scale(1)'
            }}
            onMouseEnter={() => setHoveredItem(product.id)}
            onMouseLeave={() => setHoveredItem(null)}
          >
            <div className={styles.imageWrapper} onClick={() => setSelectedImage(product.image)}>
              <img src={product.image} alt={product.name} className={styles.productImage} />
            </div>
            
          </div>
        ))}
      </div>

      {/* Image Modal */}
      {selectedImage && (
        <div className={styles.modalOverlay} onClick={() => setSelectedImage(null)}>
          <div className={styles.imageModalContent} onClick={e => e.stopPropagation()}>
            <button className={styles.modalCloseBtn} onClick={() => setSelectedImage(null)}>×</button>
            <img src={selectedImage} alt="Product" className={styles.modalImage} />
          </div>
        </div>
      )}
      </div>
      
      <Footer mode={mode} />
    </>
  );
};

export default MerchandisePage;